import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createSitInOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { Button } from '../../pixiComponents/button';
export const PixiSitInButton = ({ bounds }) => {
    const socketSend = useSocketSend();
    const onClickSitIn = useCallback(() => {
        socketSend(createSitInOutbound());
    }, [socketSend]);
    return (_jsx(Button, { pixiObjectData: { type: 'sit-in-button' }, onClick: onClickSitIn, labelProperties: { label: 'SIT IN', bitmapTextStyleType: 'button-label' }, bounds: bounds }));
};
